// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"88d29d54","322":"ef11a234","453":"ace21015","626":"d3b41c99","910":"57b39129"}[chunkId] + ".chunk.js";
};